import { Card, CardContent } from '@design-system';
import { StepFrame } from '../components/step-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import type { ConsumerStepProps } from './step-props';

export function MedicaidStep({ clientId }: ConsumerStepProps) {
  const { finish } = useConsumerFlow(clientId);

  return (
    <StepFrame
      step="medicaid"
      title="What if the remaining cost feels out of reach?"
      subtitle="You don’t have to close the entire gap right now."
      onBack={() => finish('review')}
      help={
        <>
          <p>Medicare generally doesn’t pay for ongoing custodial care when that’s the only care needed. Limited skilled-care benefits are different from long-term help with daily activities.</p>
          <p>Don’t assume an asset amount alone establishes Medicaid eligibility, or that your preferred setting will be covered.</p>
          <a
            className="text-primary underline-offset-4 hover:underline"
            href="https://www.medicaid.gov/medicaid/eligibility-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read official Medicaid eligibility guidance
          </a>
        </>
      }
      primary={{ label: 'Continue with my plan', onClick: () => finish('review') }}
    >
      <Card>
        <CardContent className="flex flex-col gap-2">
          <h2 className="text-lg font-semibold text-gray-950">Medicaid may be an option.</h2>
          <p className="text-muted-foreground text-sm">
            Eligibility depends on your state’s financial and care-needs rules. Covered settings and access
            vary. It isn’t counted as funding in this plan.
          </p>
        </CardContent>
      </Card>
    </StepFrame>
  );
}
